<template>
  <div>
    <div class="wrapper" v-if="storedLocation">
      <div class="attention">
        <img
          src="@/assets/icon_exclamation@.png"
          alt="エラー"
          width="22"
          height="86"
        />
      </div>
      <h2>物件が見つかりませんでした。</h2>
      <p>KEIAIミツカルをご利用いただきありがとうございます。この{{storedLocation.pref.name}}{{storedLocation.city.name}}の物件一覧には物件がありません。TOPページへ戻り、引き続き検索をお楽しみください。</p>
      <div class="button">
        <a class="button__confirm" href="/">
          TOPページへ
        </a>
      </div>
    </div>
    <common-footer />
  </div>
</template>

<script>
import MixinUtil from '@/plugins/mixin-utils';
import MixinAPI from '@/plugins/mixin-api';
import BehaviorLogMixin from '@/plugins/mixin-behavior-log';
import isMobile from '@/plugins/isMobile';

import CommonFooter from '@/components/parts/CommonFooter';

export default {
  name: 'SearchListNotFound',
  mixins: [MixinUtil, MixinAPI, isMobile, BehaviorLogMixin],
  props: ['preflist', 'isReady'],
  components: {
    CommonFooter,
  },
  data() {
    return {
      pref_name: '',
      city_name: '',
    };
  },

  computed: {
    storedLocation() {
      /* eslint dot-notaion: 0 */
      return this.$store.getters['getLocation'];
    },
  },
};

</script>

<style scoped lang="scss">
@charset "UTF-8";
h2 {
    font-size: 16px;
    font-weight: bold;
    margin: 40px auto 19px;
    text-align: center;
}
p {
  font-size: 14px;
  margin: auto;
  padding-bottom: 40px;
  max-width: 610px;
  line-height: 2em;
}
div.attention {
  text-align: center;
}
.wrapper {
  padding: 112px 20px;
  background-color: #F6F6F6;
}
.button {
  display:flex;
  justify-content: center;
  align-items: center;
  // margin-top:50px;
  a {
    height: 55px;
    width: 352px;
    font-size: 18px;
    border-radius: 26px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-weight:bold;
  }
  &__back {
    width:152px;
    border: 1px solid #CCC;
    background-color:#FFF;
    position: absolute;
    left:0;
  }
  &__confirm {
    color: #FFF;
    width: 264px;
    background-color: #E83532;
  }
}
</style>
